import { useTranslations } from '@/i18n/context';

export function Collections() {
  const t = useTranslations('collections');
  const items = t.raw('items') as Array<{
    tag: string;
    name: string;
    en: string;
    price: string;
    desc: string;
    specs: string[];
  }>;

  const images = [
    'https://img.alicdn.com/imgextra/i3/2216742298660/O1CN01NQZmkM2DqL5Oq98UN_!!2216742298660.jpg',
    'https://img.alicdn.com/imgextra/i4/2216742298660/O1CN01R6kdjf2DqL5NAbBoj_!!2216742298660.jpg',
    'https://img.alicdn.com/imgextra/i2/2216742298660/O1CN01dzjq9x2DqL5NqShDq_!!2216742298660.jpg',
  ];

  return (
    <section
      id="collections"
      className="relative border-t hairline bg-[color:var(--mp-cream-soft)] py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20">
        <div className="mb-16 flex flex-col justify-between gap-8 md:mb-24 md:flex-row md:items-end">
          <div>
            <div className="mb-4 text-[11px] uppercase tracking-[0.32em] text-[color:var(--mp-moss)]">
              {t('sectionLabel')}
            </div>
            <h2
              className="font-serif-cn max-w-2xl text-4xl leading-[1.2] text-[color:var(--mp-forest)] md:text-6xl"
              // eslint-disable-next-line react/no-danger -- trusted translation
              dangerouslySetInnerHTML={{ __html: t('title') }}
            />
          </div>
          <p className="max-w-md text-[15px] leading-[1.9] text-[color:var(--mp-forest)]/70">
            {t('intro')}
          </p>
        </div>

        <div className="space-y-24 md:space-y-32">
          {items.map((c, i) => {
            const reversed = i % 2 === 1;
            return (
              <article
                key={c.name}
                className="grid grid-cols-1 items-center gap-10 md:grid-cols-12 md:gap-16"
              >
                <div
                  className={`md:col-span-7 ${
                    reversed ? 'md:order-2' : 'md:order-1'
                  }`}
                >
                  <div className="group relative overflow-hidden bg-[color:var(--mp-cream)]">
                    <img
                      src={images[i]}
                      alt={c.name}
                      className="aspect-[4/5] w-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-[1.04]"
                    />
                    <div className="absolute left-6 top-6 border hairline bg-[color:var(--mp-cream)]/90 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-[color:var(--mp-forest)]">
                      0{i + 1}
                    </div>
                  </div>
                </div>

                <div
                  className={`md:col-span-5 ${
                    reversed ? 'md:order-1' : 'md:order-2'
                  }`}
                >
                  <div className="text-[11px] uppercase tracking-[0.28em] text-[color:var(--mp-caramel)]">
                    {c.tag}
                  </div>
                  <h3 className="font-serif-cn mt-4 text-3xl leading-[1.2] text-[color:var(--mp-forest)] md:text-4xl">
                    {c.name}
                  </h3>
                  <div className="font-display mt-2 text-lg italic text-[color:var(--mp-forest)]/50">
                    {c.en}
                  </div>

                  <p className="mt-6 text-[15px] leading-[1.9] text-[color:var(--mp-forest)]/80">
                    {c.desc}
                  </p>

                  <ul className="mt-8 space-y-3 border-t hairline pt-6">
                    {c.specs.map((s) => (
                      <li
                        key={s}
                        className="flex items-start gap-3 text-[13px] text-[color:var(--mp-forest)]/75"
                      >
                        <span className="mt-2 h-px w-4 shrink-0 bg-[color:var(--mp-moss)]" />
                        {s}
                      </li>
                    ))}
                  </ul>

                  <div className="mt-8 flex items-center justify-between border-t hairline pt-6">
                    <div>
                      <div className="text-[10px] uppercase tracking-[0.24em] text-[color:var(--mp-forest)]/50">
                        {t('price')}
                      </div>
                      <div className="font-display mt-1 text-2xl text-[color:var(--mp-forest)]">
                        {c.price}
                      </div>
                    </div>
                    <a
                      href="https://moepie.tmall.com/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="mp-underline text-[12px] uppercase tracking-[0.24em] text-[color:var(--mp-forest)]"
                    >
                      {t('buyNow')}
                    </a>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
